import { render, staticRenderFns } from "./ProbeName.vue?vue&type=template&id=52337b24&scoped=true&"
import script from "./ProbeName.vue?vue&type=script&lang=js&"
export * from "./ProbeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52337b24",
  null
  
)

/* custom blocks */
import block0 from "./ProbeName.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports